<template>
  <div class="row mb-3">
    <div class="col-6 col-md-12 col-lg-7">
      <div class="d-table h-100 w-100">
        <h6 class="text-light font-weight-normal mb-2 text-capitalize d-table-cell align-middle text-left text-md-center text-lg-left">
          {{ name }}
        </h6>
      </div>
    </div>
    <div class="col-6 col-md-12 col-lg-5">
      <PrettySimpleDateDisplay :date="date" />
    </div>
  </div>
</template>

<script>
import PrettySimpleDateDisplay from "@/components/common/PrettySimpleDateDisplay.vue";

export default {
  components: {
    PrettySimpleDateDisplay,
  },
  props: {
    name: { type: String, required: true },
    date: { type: String, required: true },
  },
};
</script>
